/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';

const Exclamation = (props) => (
  <SvgIcon
    style={{
      width: '88px',
      height: '88px',
    }}
    viewBox="0 0 88 88"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>22A504B3-1822-4642-AE07-0C367454DA72</title>
    <g id="Registration-UI" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="4.4---Results---Desktop-HD"
        transform="translate(-686.000000, -243.000000)"
        fillRule="nonzero"
      >
        <g id="Group" transform="translate(686.000000, 243.000000)">
          <circle id="Oval" fill="#E7EDF2" cx="44" cy="44" r="44" />
          <path
            d="M40,56.7890625 C40,55.6640569 40.3945273,54.7070352 41.1835938,53.9179688 C41.9726602,53.1289023 42.9296819,52.734375 44.0546875,52.734375 C45.1796931,52.734375 46.1367148,53.1289023 46.9257812,53.9179688 C47.7148477,54.7070352 48.109375,55.6640569 48.109375,56.7890625 C48.109375,57.9140681 47.7148477,58.8710898 46.9257812,59.6601562 C46.1367148,60.4492227 45.1796931,60.84375 44.0546875,60.84375 C42.9296819,60.84375 41.9726602,60.4492227 41.1835938,59.6601562 C40.3945273,58.8710898 40,57.9140681 40,56.7890625 Z M40,31.8984375 C40,30.1171786 40.4023397,28.8554725 41.2070312,28.1132812 C42.0117228,27.37109 42.960932,27 44.0546875,27 C45.1171928,27 46.0585896,27.3671838 46.8789062,28.1015625 C47.6992229,28.8359412 48.109375,30.0468666 48.109375,31.734375 C48.109375,32.2656277 47.98047,33.0664009 47.7226562,34.1367188 C47.4648425,35.2070366 47,36.9609253 46.328125,39.3984375 C45.921873,40.8671948 45.644532,42.0898389 45.4960938,43.0664062 C45.3476555,44.0429736 45.1093766,46.0077977 44.78125,48.9609375 L43.3984375,48.9609375 C42.9453102,45.2421689 42.6406258,42.9453169 42.484375,42.0703125 C42.3281242,41.1953081 42.0156273,39.9687579 41.546875,38.390625 C40.953122,36.3749899 40.5703134,35.0312534 40.3984375,34.359375 C40.1328112,33.3124948 40,32.4921905 40,31.8984375 Z"
            id="!"
            fill="#222C34"
          />
        </g>
      </g>
    </g>
  </SvgIcon>
);

Exclamation.propTypes = {
  title: PropTypes.string,
};

Exclamation.defaultProps = {
  title: '',
};

export default Exclamation;
